import { FacilityScreenRow } from 'app/models/facility-screen-row'
import * as types from './types'

/**
 * The read's rows, with the generation the request started under: the
 * reducer drops them if a write has bumped it since (utils/generation.ts).
 */
export const getFacilityScreen = (rows: FacilityScreenRow[], generation?: number) => ({
  type: types.GET_FACILITY_SCREEN,
  payload: { rows, generation },
})

/**
 * Flip a set of rows to a status the ledger has already accepted.
 *
 * A bulk submit / approve answers with which ids succeeded, and that is the
 * whole change — so the grid is updated from the answer rather than refetched.
 * PQS projects a command asynchronously, so a refetch fired straight after the
 * response can still be reading the old contracts.
 */
export const setFacilityScreenStatuses = (payload: {
  ids: string[]
  status: FacilityScreenRow['status']
}) => ({
  type: types.SET_FACILITY_SCREEN_STATUSES,
  payload,
})

/**
 * A write happened that the rows cannot be patched for. The grid reloads once.
 */
export const invalidateFacilityScreen = () => ({
  type: types.INVALIDATE_FACILITY_SCREEN,
  payload: null,
})

/**
 * The read failed. Clears `stale` so nothing retries forever on a persistent
 * failure; the thunk tells the user, and the next mount reloads.
 */
export const facilityScreenLoadFailed = () => ({
  type: types.FACILITY_SCREEN_LOAD_FAILED,
  payload: null,
})

export const startLoadingFacilityScreen = () => ({
  type: types.START_LOADING_FACILITY_SCREEN,
  payload: null,
})

export const stopLoadingFacilityScreen = () => ({
  type: types.STOP_LOADING_FACILITY_SCREEN,
  payload: null,
})
